module.exports = __webpack_public_path__ + "img/google-color.b861c114.svg";